import { css } from 'styled-components'

import barlowRegularWoff2 from '../assets/fonts/barlow/barlow-semi-condensed-400.woff2'
import barlowMediumWoff2 from '../assets/fonts/barlow/barlow-semi-condensed-500.woff2'

import InterRegularWoff2 from '../assets/fonts/inter/inter400.woff2'
import InterMediumWoff2 from '../assets/fonts/inter/inter500.woff2'
import InterBoldWoff2 from '../assets/fonts/inter/inter700.woff2'

const barlowNormalWeights = {
  400: [barlowRegularWoff2],
  500: [barlowMediumWoff2]
}

const interNormalWeights = {
  400: [InterRegularWoff2],
  500: [InterMediumWoff2],
  700: [InterBoldWoff2]
}

const Barlow = {
  name: 'Barlow',
  normal: barlowNormalWeights
}

const Inter = {
  name: 'Inter',
  normal: interNormalWeights
}

const createFontFaces = (family, style = 'normal') => {
  let styles = ''
  for (const [weight, formats] of Object.entries(family[style])) {
    const woff2 = formats[0]
    styles += `
      @font-face {
        font-family: '${family.name}';
        src: url(${woff2}) format('woff2');
        font-weight: ${weight};
        font-style: ${style};
        font-display: auto;
      }
    `
  }
  return styles
}

const BarlowNormal = createFontFaces(Barlow)
const InterNormal = createFontFaces(Inter)

const Fonts = css`
  ${BarlowNormal + InterNormal}
`

export default Fonts
